import ReviewsSection from './reviews-section';

export default ReviewsSection;
